import styled from 'styled-components';
import { theme } from 'modules/tetrisTheme';
export const Container = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.sm};
`;
export const ButtonText = styled.span `
  white-space: nowrap;
`;
